import React from 'react'
import { Link } from 'react-router-dom'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { Image } from '../../../../common/Image'
import { reverseUrl } from '../../../../../navigation/reverseUrl'
import { theme } from '../../../../../theme/theme'
import { getResourceCostString } from '../../../../../api/resources'
import { PostResourceCard } from '../../../../../generated/api/post-row'

interface MarketplaceItemProps {
  resource: PostResourceCard
}

export const MarketplaceItem = ({
  resource,
}: MarketplaceItemProps): JSX.Element | null => {
  const { translate } = useAppTranslation()

  return (
    <Link
      className="flex w-full cursor-pointer flex-row items-center rounded-lg p-4 hover:bg-neutral-96"
      to={reverseUrl('society:marketplace-detail', {
        id: resource.societyId,
        resourceId: resource.id,
      })}
      style={{ textDecoration: 'none' }}
    >
      <div>
        <Image
          url={resource.imageUrl}
          className="h-[120px] w-[120px] mb-4"
          imageClassName="rounded"
        />
        <div className="flex flex-1 flex-col justify-between">
          <div>
            <span
              className="break-all text-black line-clamp-1"
              style={theme.textVariants.lead}
            >
              {resource.title}
            </span>
            <p
              className="text-neutral-50 line-clamp-1"
              style={theme.textVariants.base}
            >
              {resource.description}
            </p>
          </div>
          <span style={theme.textVariants.baseBold} className="mt-1 text-black">
            {resource.isFree || resource.cost === '0'
              ? translate('marketplaceListView.item.free')
              : getResourceCostString(resource)}
          </span>
        </div>
      </div>
    </Link>
  )
}
